export default {
    baseUrl: '/api'
}



// WEBPACK FOOTER //
// ./src/config.js